// Configuration-driven modules for PROGÈRE CRM

export const STATUS_TONES = {
  actif: "green", nouveau: "blue", converti: "gold", prospect: "purple",
  brouillon: "gray", envoyee: "blue", acceptee: "green", refusee: "red",
  a_faire: "gold", termine: "green", en_cours: "blue",  haute: "red", moyenne: "gold", basse: "gray",
  chaud: "red", tiede: "gold", froid: "blue",
  gagne: "green",
  eleve: "green", moyen: "gold", faible: "gray",
  ouvert: "blue", resolu: "green",
  admin: "gold", manager: "purple", vendeur: "blue",
  residentiel: "blue", commercial: "gold", institutionnel: "purple", industriel: "red",
  gypse: "blue", peinture: "purple", nettoyage: "green", maintenance: "gold", structure: "red", autre: "gray",
  oui: "green", non: "gray",
  client_actif: "green", ancien_client: "gray", vip: "gold", a_risque: "red",
  entrepreneur_general: "blue", sous_traitant: "purple", construction: "gold",
};

export const STATUS_LABELS = {
  actif: "Actif", nouveau: "Nouveau", converti: "Converti", prospect: "Prospect",
  brouillon: "Brouillon", envoyee: "Envoyée", acceptee: "Acceptée", refusee: "Refusée",
  a_faire: "À faire", termine: "Terminé", en_cours: "En cours",
  haute: "Haute", moyenne: "Moyenne", basse: "Basse",
  chaud: "Chaud", tiede: "Tiède", froid: "Froid",
  gagne: "Gagné",
  eleve: "Élevé", moyen: "Moyen", faible: "Faible",
  ouvert: "Ouvert", resolu: "Résolu",
  admin: "Admin", manager: "Manager", vendeur: "Vendeur",
  residentiel: "Résidentiel", commercial: "Commercial", institutionnel: "Institutionnel", industriel: "Industriel",
  gypse: "Gypse", peinture: "Peinture", nettoyage: "Nettoyage", maintenance: "Maintenance", structure: "Structure", autre: "Autre",
  oui: "Oui", non: "Non",
  client_actif: "Client actif", ancien_client: "Ancien client", vip: "VIP", a_risque: "À risque",
  entrepreneur_general: "Entrepreneur général", sous_traitant: "Sous-traitant", construction: "Construction",
};

export const SECTOR_OPTS = [
  { value: "residentiel", label: "Résidentiel" }, { value: "commercial", label: "Commercial" },
  { value: "institutionnel", label: "Institutionnel" }, { value: "industriel", label: "Industriel" },
];
export const SPECIALTY_OPTS = [
  { value: "gypse", label: "Gypse" }, { value: "peinture", label: "Peinture" }, { value: "nettoyage", label: "Nettoyage" },
  { value: "maintenance", label: "Maintenance" }, { value: "structure", label: "Structure" }, { value: "autre", label: "Autre" },
];
export const YESNO_OPTS = [{ value: "non", label: "Non" }, { value: "oui", label: "Oui" }];
export const SEGMENT_OPTS = [
  { value: "client_actif", label: "Client actif" }, { value: "prospect", label: "Prospect" },
  { value: "ancien_client", label: "Ancien client" }, { value: "vip", label: "VIP" }, { value: "a_risque", label: "À risque" },
  { value: "entrepreneur_general", label: "Entrepreneur général" }, { value: "sous_traitant", label: "Sous-traitant" },
  { value: "residentiel", label: "Résidentiel" }, { value: "commercial", label: "Commercial" },
  { value: "institutionnel", label: "Institutionnel" }, { value: "construction", label: "Construction" },
  { value: "nettoyage", label: "Nettoyage" }, { value: "maintenance", label: "Maintenance" },
];
export const LEAD_STATUS_OPTS = [
  { value: "nouveau", label: "Nouveau" }, { value: "en_cours", label: "En cours" }, { value: "gagne", label: "Gagné" },
];

const sel = (arr) => arr.map((v) => ({ value: v, label: STATUS_LABELS[v] || v }));

export const MODULES = {
  prospects: {
    endpoint: "prospects", title: "Prospects", subtitle: "Gérez vos prospects et leur qualification",
    columns: [
      { key: "name", label: "Nom" },
      { key: "company", label: "Entreprise" },
      { key: "type", label: "Type" },
      { key: "email", label: "Courriel" },
      { key: "status", label: "Statut", badge: true },
    ],
    fields: [
      { key: "name", label: "Nom", type: "text" },
      { key: "company", label: "Entreprise", type: "text" },
      { key: "type", label: "Type", type: "text" },
      { key: "email", label: "Courriel", type: "text" },
      { key: "phone", label: "Téléphone", type: "text" },
      { key: "source", label: "Source", type: "text" },
      { key: "potential_value", label: "Valeur potentielle ($)", type: "number" },
      { key: "interest", label: "Niveau d'intérêt", type: "select", options: [{ value: "eleve", label: "Élevé" }, { value: "moyen", label: "Moyen" }, { value: "faible", label: "Faible" }] },
      { key: "deadline", label: "Date limite de soumission", type: "date" },
      { key: "status", label: "Statut", type: "select", options: sel(["nouveau", "actif", "converti"]) },
      { key: "tags", label: "Segments", type: "tags", options: SEGMENT_OPTS },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
    filters: [
      { key: "status", options: sel(["actif", "nouveau", "converti"]) },
      { key: "tag", options: SEGMENT_OPTS },
    ],
    convert: true, dedupe: true, importable: true,
  },
  clients: {
    endpoint: "clients", title: "Clients", subtitle: "Votre portefeuille clients actifs",
    columns: [
      { key: "name", label: "Nom" },
      { key: "company", label: "Entreprise" },
      { key: "owner", label: "Responsable" },
      { key: "sector", label: "Secteur", badge: true },
      { key: "tags", label: "Segments", tags: true },
      { key: "lead_status", label: "Statut lead", badge: true },
    ],
    fields: [
      { key: "name", label: "Nom", type: "text" },
      { key: "company", label: "Entreprise", type: "text" },
      { key: "email", label: "Courriel", type: "text" },
      { key: "phone", label: "Téléphone", type: "text" },
      { key: "address", label: "Adresse", type: "text" },
      { key: "lead_status", label: "Statut du lead", type: "select", options: LEAD_STATUS_OPTS },
      { key: "sector", label: "Secteur d'activité", type: "select", options: SECTOR_OPTS },
      { key: "owner", label: "Responsable commercial", type: "dynamic", source: "team" },
      { key: "client_type", label: "Type de client", type: "select", options: [
        { value: "residentiel", label: "Résidentiel" }, { value: "commercial", label: "Commercial" },
        { value: "institutionnel", label: "Institutionnel" }, { value: "entrepreneur_general", label: "Entrepreneur général" },
        { value: "sous_traitant", label: "Sous-traitant" }] },
      { key: "status", label: "Statut", type: "select", options: sel(["actif", "prospect"]) },
      { key: "tags", label: "Segments", type: "tags", options: SEGMENT_OPTS },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
    filters: [
      { key: "lead_status", options: LEAD_STATUS_OPTS },
      { key: "sector", options: SECTOR_OPTS },
      { key: "owner", dynamic: "team" },
      { key: "created", type: "daterange" },
      { key: "tag", options: SEGMENT_OPTS },
    ],
    kanban: { field: "lead_status", columns: LEAD_STATUS_OPTS },
    punch: true, timeline: true, importable: true,
  },
  contacts: {
    endpoint: "contacts", title: "Contacts", subtitle: "Interlocuteurs chez vos clients",
    columns: [
      { key: "name", label: "Nom" },
      { key: "client", label: "Client" },
      { key: "role", label: "Rôle" },
      { key: "email", label: "Courriel" },
      { key: "phone", label: "Téléphone" },
    ],
    fields: [
      { key: "name", label: "Nom", type: "text" },
      { key: "client", label: "Client", type: "text" },
      { key: "role", label: "Rôle", type: "text" },
      { key: "email", label: "Courriel", type: "text" },
      { key: "phone", label: "Téléphone", type: "text" },
    ],
  },
  opportunites: {
    endpoint: "opportunities", title: "Opportunités", subtitle: "Suivez vos opportunités de vente",
    columns: [
      { key: "title", label: "Opportunité" },
      { key: "client", label: "Client" },
      { key: "value", label: "Valeur", money: true },
      { key: "sector", label: "Secteur", badge: true },
      { key: "stage", label: "Étape", badge: true },
      { key: "probability", label: "Prob.", suffix: "%" },
    ],
    fields: [
      { key: "title", label: "Titre", type: "text" },
      { key: "client", label: "Client", type: "text" },
      { key: "value", label: "Valeur ($)", type: "number" },
      { key: "stage", label: "Étape", type: "select", options: [
        { value: "nouveau", label: "Nouveau" }, { value: "qualification", label: "Qualification" },
        { value: "proposition", label: "Proposition" }, { value: "negociation", label: "Négociation" },
        { value: "gagne", label: "Gagné" }, { value: "perdu", label: "Perdu" }] },
      { key: "probability", label: "Probabilité (%)", type: "number" },
      { key: "close_date", label: "Date de clôture", type: "date" },
      { key: "section:construction", label: "Détails chantier (construction)", type: "section" },
      { key: "project_type", label: "Type de projet", type: "text" },
      { key: "sector", label: "Secteur", type: "select", options: SECTOR_OPTS },
      { key: "specialty", label: "Spécialité", type: "select", options: SPECIALTY_OPTS },
      { key: "site_address", label: "Adresse du chantier", type: "text" },
      { key: "estimator", label: "Estimateur assigné", type: "text" },
      { key: "budget", label: "Budget approximatif ($)", type: "number" },
      { key: "start_date", label: "Date de début prévue", type: "date" },
      { key: "plans_received", label: "Plans reçus", type: "select", options: YESNO_OPTS },
      { key: "urgent", label: "Estimation urgente", type: "select", options: YESNO_OPTS },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
    filters: [
      { key: "stage", options: [
        { value: "nouveau", label: "Nouveau" }, { value: "qualification", label: "Qualification" },
        { value: "proposition", label: "Proposition" }, { value: "negociation", label: "Négociation" },
        { value: "gagne", label: "Gagné" }, { value: "perdu", label: "Perdu" }] },
      { key: "sector", options: SECTOR_OPTS },
      { key: "specialty", options: SPECIALTY_OPTS },
    ],
  },
  soumissions: {
    endpoint: "quotes", title: "Soumissions", subtitle: "Devis brouillons, envoyés et acceptés",
    columns: [
      { key: "title", label: "Soumission" },
      { key: "client", label: "Client" },
      { key: "amount", label: "Montant", money: true },
      { key: "status", label: "Statut", badge: true },
    ],
    fields: [
      { key: "title", label: "Titre", type: "text" },
      { key: "client", label: "Client", type: "text" },
      { key: "amount", label: "Montant ($)", type: "number" },
      { key: "status", label: "Statut", type: "select", options: sel(["brouillon", "envoyee", "acceptee", "refusee"]) },
      { key: "lost_reason", label: "Raison (si refusée)", type: "select", options: [
        { value: "", label: "—" }, { value: "Prix trop élevé", label: "Prix trop élevé" },
        { value: "Mauvais délai", label: "Mauvais délai" }, { value: "Client a choisi un compétiteur", label: "Client a choisi un compétiteur" },
        { value: "Manque d'information", label: "Manque d'information" }, { value: "Mauvais suivi", label: "Mauvais suivi" },
        { value: "Projet annulé", label: "Projet annulé" }, { value: "Autre raison", label: "Autre raison" }] },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
    filters: [{ key: "status", options: sel(["brouillon", "envoyee", "acceptee", "refusee"]) }],
    pdf: true, convertProject: true,
  },
  taches: {
    endpoint: "tasks", title: "Tâches", subtitle: "Tâches et relances à effectuer",
    columns: [
      { key: "title", label: "Tâche" },
      { key: "type", label: "Type" },
      { key: "due_date", label: "Échéance" },
      { key: "priority", label: "Priorité", badge: true },
      { key: "status", label: "Statut", badge: true },
    ],
    fields: [
      { key: "title", label: "Titre", type: "text" },
      { key: "type", label: "Type", type: "select", options: [{ value: "relance", label: "Relance" }, { value: "appel", label: "Appel" }, { value: "email", label: "Courriel" }] },
      { key: "due_date", label: "Échéance", type: "date" },
      { key: "priority", label: "Priorité", type: "select", options: sel(["haute", "moyenne", "basse"]) },
      { key: "status", label: "Statut", type: "select", options: sel(["a_faire", "termine"]) },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
    filters: [
      { key: "status", options: sel(["a_faire", "termine"]) },
      { key: "priority", options: sel(["haute", "moyenne", "basse"]) },
    ],
  },
  communications: {
    endpoint: "communications", title: "Communications", subtitle: "Historique des échanges clients",
    columns: [
      { key: "type", label: "Type", badge: true },
      { key: "subject", label: "Sujet" },
      { key: "client", label: "Client" },
      { key: "date", label: "Date" },
    ],
    fields: [
      { key: "type", label: "Type", type: "select", options: [{ value: "email", label: "Courriel" }, { value: "appel", label: "Appel" }, { value: "note", label: "Note" }] },
      { key: "subject", label: "Sujet", type: "text" },
      { key: "client", label: "Client", type: "text" },
      { key: "date", label: "Date", type: "date" },
      { key: "content", label: "Contenu", type: "textarea" },
    ],
    filters: [{ key: "type", options: [{ value: "email", label: "Courriel" }, { value: "appel", label: "Appel" }, { value: "note", label: "Note" }] }],
  },
  utilisateurs: {
    endpoint: "team", title: "Utilisateurs", subtitle: "Membres de l'équipe et rôles",
    columns: [
      { key: "name", label: "Nom" },
      { key: "email", label: "Courriel" },
      { key: "role", label: "Rôle", badge: true },
      { key: "status", label: "Statut", badge: true },
    ],
    fields: [
      { key: "name", label: "Nom", type: "text" },
      { key: "email", label: "Courriel", type: "text" },
      { key: "role", label: "Rôle", type: "select", options: [{ value: "admin", label: "Admin" }, { value: "manager", label: "Manager" }, { value: "vendeur", label: "Vendeur" }] },
      { key: "status", label: "Statut", type: "select", options: [{ value: "actif", label: "Actif" }, { value: "inactif", label: "Inactif" }] },
    ],
    filters: [{ key: "role", options: [{ value: "admin", label: "Admin" }, { value: "manager", label: "Manager" }, { value: "vendeur", label: "Vendeur" }] }],
  },
  tickets: {
    endpoint: "tickets", title: "Support technicien", subtitle: "Billets d'assistance pour vos techniciens et clients",
    columns: [
      { key: "subject", label: "Sujet" },
      { key: "category", label: "Catégorie" },
      { key: "requester", label: "Demandeur" },
      { key: "priority", label: "Priorité", badge: true },
      { key: "status", label: "Statut", badge: true },
    ],
    fields: [
      { key: "subject", label: "Sujet", type: "text" },
      { key: "category", label: "Catégorie", type: "select", options: [
        { value: "Technique", label: "Technique" }, { value: "PROGÈRE PUNCH", label: "PROGÈRE PUNCH" },
        { value: "Facturation", label: "Facturation" }, { value: "Formation", label: "Formation" }, { value: "Autre", label: "Autre" }] },
      { key: "requester", label: "Demandeur", type: "text" },
      { key: "priority", label: "Priorité", type: "select", options: sel(["haute", "moyenne", "basse"]) },
      { key: "status", label: "Statut", type: "select", options: sel(["ouvert", "en_cours", "resolu"]) },
      { key: "description", label: "Description", type: "textarea" },
    ],
    filters: [
      { key: "status", options: sel(["ouvert", "en_cours", "resolu"]) },
      { key: "priority", options: sel(["haute", "moyenne", "basse"]) },
    ],
  },
};
